<template>
	<div class="AccountSetup">
		<div class="AccountSetup__card">
			<div class="AccountSetup__card--content">
				<!-- <div class="AccountSetup__card--top">
					<div class="AccountSetup__card--top-center">
					</div>
				</div> -->
						<!-- <p class="text-teal cursor-pointer text-center">
							Upgrade
						</p>
						<p class="mt-4 text-center" style="font-size: 25px;">
							Welcome to NymbleUp
						</p> -->
				<div class="AccountSetup__starting--steps ">
					<el-row>
						<el-col :xs="10" :sm="10" :md="12" :lg="12" :xl="12">
							<div class="flex">
								<div>
									<p class="text-teal italic" style="font-size:24px;width:99px;">
										Step 1 :
									</p>
								</div>
								<div>
									<p>Create Accounts</p>
									<p class="text-sm italic " style="color:#999">
										Create accounts for Head Office, Stores, Users, Kitchen and
										Suppliers
									</p>
								</div>
							</div>
						</el-col>
						<el-col :xs="14" :sm="14" :md="12" :lg="12" :xl="12">
							<div style="float:right">
								<button
									class="AccountSetup__steps--btn"
									@click="
										$router.push({ name: 'AppUploadCsvOrAddStoreDetails' }).catch(()=>{})
									"
								>
									Create Account
								</button>
							</div>
						</el-col>
					</el-row>
					<el-row style="padding-top:70px;">
						<el-col :xs="10" :sm="10" :md="12" :lg="12" :xl="12">
							<div class="flex">
								<div>
									<p class="text-teal italic" style="font-size:24px;width:99px;">
										Step 2 :
									</p>
								</div>
								<div>
									<p>Add Item Master</p>
									<p class="text-sm italic " style="color:#999">
										about every inventory item. This information includes the description, unit of
									measure, weight, dimensions, quantity, and so forth for every
									item.
									</p>
								</div>
							</div>
						</el-col>
						<el-col :xs="14" :sm="14" :md="12" :lg="12" :xl="12">
							<div style="float:right">
								<button
									class="AccountSetup__steps--btn"
									@click="$router.push({ path: `/nymble-dashboard/item-master/` }).catch(()=>{})"
								>
									Item Master
								</button>
							</div>
						</el-col>
					</el-row>
					<el-row style="padding-top:70px;">
						<el-col :xs="10" :sm="10" :md="12" :lg="12" :xl="12">
							<div class="flex">
								<div>
									<p class="text-teal italic" style="font-size:24px;width:99px;">
										Step 3 :
									</p>
								</div>
								<div>
									<p>Add Sales History</p>
									<p class="text-sm italic " style="color:#999">
										Adding past sales data for each store is a key step to
									generate forecast data
									</p>
								</div>
							</div>
						</el-col>
						<el-col :xs="14" :sm="14" :md="12" :lg="12" :xl="12">
							<div style="float:right">
								<button
									class="AccountSetup__steps--btn"
									@click="
										$router.push({ path: `/nymble-dashboard/past-sales-data/` }).catch(()=>{})
									"
								>
									Add Sales
								</button>
							</div>
						</el-col>
					</el-row>
					<el-row style="padding-top:70px;">
						<el-col :xs="10" :sm="10" :md="12" :lg="12" :xl="12">
							<div class="flex">
								<div>
									<p class="text-teal italic" style="font-size:24px;width:99px;">
										Step 4 :
									</p>
								</div>
								<div>
									<p>Add your annual events or Promotion calendar </p>
									<p class="text-sm italic " style="color:#999">
										 Planned Events And promotion calendar for each store
									</p>
								</div>
							</div>
						</el-col>
						<el-col :xs="14" :sm="14" :md="12" :lg="12" :xl="12">
							<div style="float:right">
								<button class="AccountSetup__steps--btn" @click="$router.push({ name: `EventList` }).catch(()=>{})">
							       Events and Promotion
						        </button>
							</div>
						</el-col>
					</el-row>
					<div class="horizontal-line" />
					<p class="mt-8">
						If you have subscribed for Inventory and Expiry Management, Please
						upload following files
					</p>
					<el-row style="padding-top:70px;">
						<el-col :xs="10" :sm="10" :md="12" :lg="12" :xl="12">
							<div class="flex">
								<div>
									<p class="text-teal italic" style="font-size:24px;width:99px;">
										Step 5 :
									</p>
								</div>
								<div>
									<p>Add Current Inventory</p>
									<p class="text-sm italic " style="color:#999">
										Setup your current stock levels
									</p>
								</div>
							</div>
						</el-col>
						<el-col :xs="14" :sm="14" :md="12" :lg="12" :xl="12">
							<div style="float:right">
								<button class="AccountSetup__steps--btn"
								@click="
									() =>
										$router.push({
											name: 'NymbleDashboard',
											params: { pageName: 'inventory-account-setup' }
										}).catch(()=>{})
								">
							      Current Inventory
						        </button>
							</div>
						</el-col>
					</el-row>
					<el-row style="padding-top:70px;">
						<el-col :xs="10" :sm="10" :md="12" :lg="12" :xl="12">
							<div class="flex">
								<div>
									<p class="text-teal italic" style="font-size:24px;width:99px;">
										Step 6 :
									</p>
								</div>
								<div>
									<p>Bill of Material / Recipe Build</p>
									<p class="text-sm italic " style="color:#999">
										Add comprehensive inventory of raw materials, assemblies,
									subassemblies and quantities needed to make a product.
									</p>
								</div>
							</div>
						</el-col>
						<el-col :xs="14" :sm="14" :md="12" :lg="12" :xl="12">
							<div style="float:right">
								<button
									class="AccountSetup__steps--btn"
									@click="$router.push({ path: `/nymble-dashboard/recipe/` }).catch(()=>{})"
								>
									BOM
								</button>
							</div>
						</el-col>
					</el-row>
				</div>
					<!-- <div class="AccountSetup__all--steps">
						<div class="text">
							<p class="text-teal italic" style="font-size:24px;width:99px;">
								Step 2 :
							</p>
							<p class="text-base text-black" style="max-width: 690px;">
								Add Item Master <br />
								<span class="text-sm italic	" style="color:#999"
									>about every inventory item. This information includes the
									description, unit of measure, weight, dimensions, quantity,
									and so forth for every item.
								</span>
							</p>
						</div>
						<button
							class="AccountSetup__steps--btn"
							@click="$router.push({ path: `/nymble-dashboard/item-master/` })"
						>
							Item Master
						</button>
					</div> -->
					<!-- <div class="AccountSetup__all--steps">
						<div class="text">
							<p class="text-teal italic" style="font-size:24px;width:99px;">
								Step 3 :
							</p>
							<p class="text-base text-black">
								Add Sales History <br />
								<span class="text-sm w-1/2 italic" style="color:#999"
									>Adding past sales data for each store is a key step to
									generate forecast data
								</span>
							</p>
						</div>
						<button
							class="AccountSetup__steps--btn"
							@click="
								$router.push({ path: `/nymble-dashboard/past-sales-data/` })
							"
						>
							Add Sales
						</button>
					</div> -->

					<!-- <div class="AccountSetup__all--steps">
						<div class="text">
							<p class="text-teal italic" style="font-size:24px;width:99px;">
								Step 4 :
							</p>
							<p class="text-base text-black">
								Add your annual events or Promotion calendar for each store
								Upcoming Planned Events <br />
								<span class="text-sm italic" style="color:#999"
									>motion calendar for each store
								</span>
							</p>
						</div>
						<button class="AccountSetup__steps--btn">
							Events and Promotion
						</button>
					</div> -->

					<!-- <div class="AccountSetup__all--steps">
						<div class="text">
							<p class="text-teal italic" style="font-size:24px;width:99px;">
								Step 5 :
							</p>
							<p class="text-base text-black">
								Below Add Current Inventory <br />
								<span class="text-sm w-1/2 italic" style="color:#999"
									>Setup your current stock levels
								</span>
							</p>
						</div>
						<button class="AccountSetup__steps--btn">
							Current Inventory
						</button>
					</div> -->
					<!-- <div class="AccountSetup__all--steps">
						<div class="text">
							<p class="text-teal italic" style="font-size:24px;width:99px;">
								Step 6 :
							</p>
							<span class="text-base text-black" style="max-width:690px">
								Bill of Material / Recipe Build <br />
								<span class="text-sm w-1/2 italic" style="color:#999"
									>Add comprehensive inventory of raw materials, assemblies,
									subassemblies and quantities needed to make a product.
								</span>
							</span>
						</div>
						<button
							class="AccountSetup__steps--btn"
							@click="$router.push({ path: `/nymble-dashboard/recipe/` })"
						>
							BOM
						</button>
					</div> -->
			</div>
		</div>
	</div>
</template>

<script>
import Papa from "papaparse";
import jsonSize from "json-size";
import CsvService from "../../services/csvService";
import CommonService from "../../services/commonService";
import { ArticleMaster } from "../../../mixins/processCsvFunctions/articleMaster.mixin";
import { PastSales } from "../../../mixins/processCsvFunctions/pastSales.mixin";
import moment from "moment";
export default {
	name: "AccountSetup",
	components: {},
	mixins: [ArticleMaster, PastSales],
	props: [],
	data() {
		return {
			// outlets: [],
			// selectedOutletId: "",
			// selectedFileType: "",
			// errorsInCsv: [],
			// articleCodeUniqueValueCheck: {},
			// CategoryCheckInAM: {
			// 	empty: false,
			// 	full: false
			// },
			// SubCategoryCheckInAM: {
			// 	empty: false,
			// 	full: false
			// },
			// dialogVisible: false
		};
	},
	computed: {},
	created() {
		// this.getOutlets();
	},
	mounted() {
		String.prototype.hashCode = function() {
			var hash = 0,
				i = 0,
				len = this.length;
			while (i < len) {
				hash = ((hash << 5) - hash + this.charCodeAt(i++)) << 0;
			}
			return hash;
		};
	},
	methods: {
		// getCsvFile(event, fileId) {
		// 	if (fileId == "articleMaster") {
		// 		this.selectedFileType = "article_master";
		// 		this.handleFileSelect(event.target.files[0], fileId);
		// 	}
		// 	if (fileId == "pastSales") {
		// 		this.selectedFileType = "past_sales";
		// 		this.handleFileSelect(event.target.files[0], fileId);
		// 	}
		// 	var element = document.getElementById(fileId);
		// 	element.onclick = function() {
		// 		this.value = null;
		// 	};
		// },
		// handleFileSelect(file, csvName) {
		// 	// parse csv file data into json object and
		// 	// send the data to validate to check if
		// 	//there are any errors
		// 	Papa.LocalChunkSize = 2000000;
		// 	Papa.parse(file, {
		// 		header: true,
		// 		dynamicTyping: true,
		// 		skipEmptyLines: true,
		// 		chunk: function(chunk, parser) {
		// 			console.log("chunk", chunk);
		// 			this.processCsvData(chunk, csvName);
		// 			return chunk;
		// 		}.bind(this),
		// 		complete: results => {
		// 			if (this.errorsInCsv.length) {
		// 				this.dialogVisible = true;
		// 			}
		// 			console.log("parse complete");
		// 			if (!this.errorsInCsv.length) {
		// 				if (this.pastSalesDates.length) {
		// 					var minDate = moment
		// 						.min(this.pastSalesDates)
		// 						.format("YYYY-MM-DD");
		// 					var maxDate = moment
		// 						.max(this.pastSalesDates)
		// 						.format("YYYY-MM-DD");
		// 				}
		// 				var formData = new FormData();
		// 				formData.append("file", file);
		// 				formData.append("type", this.selectedFileType);
		// 				formData.append("outlets", this.selectedOutletId);
		// 				formData.append(
		// 					"start_date",
		// 					this.pastSalesDates.length ? minDate : ""
		// 				);
		// 				formData.append(
		// 					"end_date",
		// 					this.pastSalesDates.length ? maxDate : ""
		// 				);
		// 				CsvService.csvFileUpload(formData)
		// 					.then(response => {
		// 						if (response.status == 200) {
		// 							// this.resetVariables();
		// 							this.$notify.success({
		// 								title: "Success",
		// 								message: "Success",
		// 								type: "success"
		// 							});
		// 						} else {
		// 							this.$notify.success({
		// 								title: "Error",
		// 								message: "unable to upload",
		// 								type: "error"
		// 							});
		// 						}
		// 					})
		// 					.catch(error => {
		// 						console.log(error);
		// 					})
		// 					.finally(() => {
		// 						this.resetVariables();
		// 					});
		// 			}
		// 		}
		// 	});
		// },
		// processCsvData(chunk, csvName) {
		// 	if (csvName === "articleMaster") {
		// 		this.processArticleMaster(chunk);
		// 	}
		// 	if (csvName === "pastSales") {
		// 		this.processPastSales(chunk);
		// 	}
		// },
		// getOutlets() {
		// 	CommonService.getOutlets()
		// 		.then(response => {
		// 			if (response.status == 200) {
		// 				this.outlets = JSON.parse(response.data).results;
		// 			}
		// 		})
		// 		.catch(error => {
		// 			console.log("error", error);
		// 		});
		// },
		// closeTableDialog() {
		// 	this.dialogVisible = false;
		// 	this.resetVariables();
		// },
		// resetVariables() {
		// 	this.pastSalesDates = [];
		// 	this.selectedFileType = "";
		// 	this.selectedOutletId = "";
		// 	this.errorsInCsv = [];
		// 	this.articleCodeUniqueValueCheck = {};
		// 	this.CategoryCheckInAM = {
		// 		empty: false,
		// 		full: false
		// 	};
		// 	this.SubCategoryCheckInAM = {
		// 		empty: false,
		// 		full: false
		// 	};
		// }
	}
};
</script>

<style lang="scss" scoped>
@import "./AccountSetup.scss";
@import "../../components/admin/appTable/AppTable.scss";
</style>
<style>
.el-notification {
	z-index: 9999 !important;
}
.inputfile + label {
	font-size: 1.25em;
	font-weight: 700;
	color: white;
	background-color: black;
	display: inline-block;
}

.inputfile:focus + label,
.inputfile + label:hover {
	background-color: red;
}
</style>
